// Translations
import form from '../sections/form/translations/ua'

// Translation: Two-factor authentication > Landing (Ukrainian)
export default Object.freeze({
	sections: { form }
})
